<template>
    <div>
        <ul class="container" v-for="(activity, idx) in activityData" :key="idx">
            <template v-if="activity">
                <li v-if="activity.status !== undefined">
                    <div>场次开关:</div>
                    {{ activityStatus.get(activity.status) }}
                </li>
                <li v-if="activity.sessionName">
                    <div>场次名称:</div>
                    {{ activity.sessionName }}
                </li>
                <li v-if="activity.startTime">
                    <div>演出时间:</div>
                    {{ `${activity.startTime} 至 ${activity.endTime}` }}
                </li>
				<li v-if="activity.canRefundTime">
				    <div>申请退票截止时间:</div>
				    {{ activity.canRefundTime }}
				</li>
                <li v-if="activity.performers && activity.performers.length > 0 || activity.customPerformer">
                    <div>艺人阵容:</div>
                    <div v-if="current" class="flex-right">
                        <p v-if="activity.performers && activity.performers.length > 0 || activity.performerList">正式艺人: 
                            {{ activity.performers && activity.performers.length > 0 ? (activity.performers.map(v => v.name)).toString() : "" }}
                            {{ activity.performers && activity.performers.length > 0  && activity.performerList && activity.performerList.length > 0 ? ',' : '' }} 
                            {{ activity.performerList && activity.performerList.length > 0 ? (activity.performerList.map(v => v.name)).toString() : "" }}
                        </p>
                        <div v-if="activity.customPerformer && activity.customPerformer.length > 0">自定义艺人: 
                            <!-- <el-button type="text" size="small" @click="performersBind(idx)" v-if="status === 1">{{ activity.customPerformer }}</el-button> -->
                            <template v-if="status === 1">
                                <el-tag v-for="(v, i) in activity.customPerformer" :key="i" type="info" size="mini" class="ML10" @click="performersBind(v,idx)">{{ v.name }}</el-tag>
                            </template>
                            <template v-else>{{activity.customPerformer.map(v => v.name).toString()}}</template>
                            <div v-if="status === 1" class="color-danger">用户使用了自定义艺人，点击艺人阵容进行处理</div>
                        </div>
                    </div>
                    <div v-else class="flex-right">
                        {{ activity.performers && activity.performers.length > 0 ? (activity.performers.map(v => v.name)).toString() : "" }}
                        {{ activity.customPerformer && activity.customPerformer.length > 0 ? (activity.customPerformer.map(v => v.name)).toString() : "" }}
                    </div>
                </li>
				<li v-if="activity.guests && activity.guests.length > 0 || activity.customGuest">
				    <div>嘉宾阵容:</div>
				    <div v-if="current" class="flex-right">
				        <p v-if="activity.guests && activity.guests.length > 0 || activity.performerList2">正式艺人: 
				            {{ activity.guests && activity.guests.length > 0 ? (activity.guests.map(v => v.name)).toString() : "" }}
				            {{ activity.guests && activity.guests.length > 0  && activity.performerList2 && activity.performerList2.length > 0 ? ',' : '' }} 
				            {{ activity.performerList2 && activity.performerList2.length > 0 ? (activity.performerList2.map(v => v.name)).toString() : "" }}
				        </p>
				        <div v-if="activity.customGuest && activity.customGuest.length > 0">自定义嘉宾: 
				            <!-- <el-button type="text" size="small" @click="guestsBind(idx)" v-if="status === 1">{{ activity.customGuest }}</el-button> -->
                            <template v-if="status === 1">
                                <el-tag v-for="(v, i) in activity.customGuest" :key="i" type="info" size="mini" class="ML10" @click="guestsBind(v,idx)">{{ v.name }}</el-tag>
                            </template>
                            <template v-else>{{activity.customGuest.map(v => v.name).toString()}}</template>
                            <div v-if="status === 1" class="color-danger">用户使用了自定义嘉宾，点击嘉宾阵容进行处理</div>
				        </div>
				    </div>
				    <div v-else class="flex-right">
				        {{ activity.guests && activity.guests.length > 0 ? (activity.guests.map(v => v.name)).toString() : "" }}
				        {{ activity.customGuest && activity.customGuest.length > 0 ? (activity.customGuest.map(v => v.name)).toString() : "" }}
				    </div>
				</li>
				
                <AddTicket :ticketPrices="activity.ticketPrices"/>
            </template>
            <template v-else>
                <li>
                    <div class="del-activity">该场次已删除</div>    
                </li> 
            </template>
            <el-divider v-if="idx <  activityData.length -1"></el-divider>         
        </ul>

        <!-- 绑定正式艺人 -->
        <!-- <el-drawer title="绑定正式艺人" :visible.sync="performerBindVisible" size="auto" :destroy-on-close="true" append-to-body>
            <div class="drawer-content">
                <el-alert type="warning" :closable="false">
                    <div>用户编辑了自定义艺人：{{activityData[index] && activityData[index].customPerformer}}</div>
                    <div>请酌情绑定对应的正式艺人</div>
                    <div>如果系统中没有需要的正式艺人，请先<el-button size="mini" type="text" @click="addPerformer">创建正式艺人</el-button>，然后再来绑定</div>
                </el-alert>
                <el-form :model="performer" ref="performerForm" label-position="top" class="MT20">
                    <el-form-item prop="value" :rules="[{required: true, message: '请选择艺人'}]">
                        <span slot="label">绑定正式艺人: </span>
                        <el-select 
                            v-model="performer.value" 
                            filterable 
                            remote
                            multiple
                            placeholder="请输入正式艺人"
                            :remote-method="searchArtist"
                            :loading="userLoading"
                            size="medium"
                            value-key="id">
                            <el-option
                                v-for="item in activityData[index].artistList"
                                :key="item.id"
                                :label="item.name"
                                :value="item" 
                                :disabled="activityData[index].performers && activityData[index].performers.find(v => v.id === item.id) ? true : false">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="performerBindVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="performerSubmit" size="medium">确 定</el-button>
            </div>
        </el-drawer> -->
		<!-- 绑定正式嘉宾 -->
		<!-- <el-drawer title="绑定正式嘉宾" :visible.sync="performerBindVisible2" size="auto" :destroy-on-close="true" append-to-body>
		    <div class="drawer-content">
		        <el-alert type="warning" :closable="false">
		            <div>用户编辑了自定义嘉宾：{{activityData[index] && activityData[index].customGuest}}</div>
		            <div>请酌情绑定对应的正式嘉宾</div>
		            <div>如果系统中没有需要的正式嘉宾，请先<el-button size="mini" type="text" @click="addPerformer">创建正式嘉宾</el-button>，然后再来绑定</div>
		        </el-alert>
		        <el-form :model="guest" ref="guestForm" label-position="top" class="MT20">
		            <el-form-item prop="value" :rules="[{required: true, message: '请选择嘉宾'}]">
		                <span slot="label">绑定正式嘉宾: </span>
		                <el-select 
		                    v-model="guest.value" 
		                    filterable 
		                    remote
		                    multiple
		                    placeholder="请输入正式嘉宾"
		                    :remote-method="searchGuests"
		                    :loading="userLoading"
		                    size="medium"
		                    value-key="id">
		                    <el-option
		                        v-for="item in activityData[index].guestsList"
		                        :key="item.id"
		                        :label="item.name"
		                        :value="item" 
		                        :disabled="activityData[index].guests && activityData[index].guests.find(v => v.id === item.id) ? true : false">
		                    </el-option>
		                </el-select>
		            </el-form-item>
		        </el-form>
		    </div>
		    <div class="drawer-footer">
		        <el-button @click="performerBindVisible2 = false" size="medium">取 消</el-button>
		        <el-button type="primary" @click="guestSubmit" size="medium">确 定</el-button>
		    </div>
		</el-drawer> -->
        <artist-add ref="artistAdd" @onUpdate="updatePerformer"></artist-add>
    </div>
    
</template>

<script>
import {activityStatus} from './mixins.js';
import AddTicket from './addTicket';
// import {fetchUser} from '@/assets/js/commonApi';
import ArtistAdd from '@/components/ArtistAdd';
export default {
    mixins: [activityStatus],
    components: {
        AddTicket,
        ArtistAdd
    },
    props: {
        activityData: {
            type: Array,
            default: ()=> []
        },
        current: {
            type: Boolean,
            default: false
        },
        status: {
            type: Number,
            default: 1
        }
    },
    data(){
        return{
            // 绑定艺人相关
            // userLoading: false,
            // performerBindVisible: false,
			// performerBindVisible2:false,
            // performerList:[],
			// performerList2:[],
            // artistList:[],
			// guestsList:[],
            index: 0,
			// artistType: 1,
            performer:{
                value:[]
            },
			guest:{
			    value:[]
			},
            artistType: 1, // 1:艺人 2:嘉宾
            currentArtist: null,
        }
    },
    methods:{
        //搜索艺人
        // async searchArtist(query){
        //     if(query !== ""){
        //         this.userLoading = true;
        //         const res = await fetchUser({
        //             queryValue:query,
        //             userType:2,
        //         }).finally(() => {
        //             this.userLoading = false;
        //         });
                
        //         const { state, result } = res.data;
                
        //         if (state == 1 && result) {
        //             const _activityData = [...this.activityData];
        //             _activityData[this.index].artistList = [...result];
        //             this.$emit('update:activityData',_activityData);
        //         }
        //     }
        // },
		// searchArtist(query) {
		// 	this.searchUser(query, 2, 'artistList');
		// },
		// searchGuests(query) {
		// 	this.searchUser(query, 2, 'guestsList');
		// },
		// 搜索艺人
		// async searchUser(query, userType,name) {
		// 	if (query !== "") {
		// 		this.userLoading = true;
		// 		const res = await fetchUser({
		// 			queryValue: query,
		// 			userType: userType,
		// 		}).finally(() => {
		// 			this.userLoading = false;
		// 		});
		
		// 		const {
		// 			state,
		// 			result
		// 		} = res.data;
		
		// 		if (state == 1 && result) {
					
					
		// 			if( name == 'artistList' ){
		// 				const _activityData = [...this.activityData];
		// 				_activityData[this.index].artistList = [...result];
		// 				this.$emit('update:activityData',_activityData);					
		// 			}
		// 			if( name == 'guestsList' ){
		// 				const _activityData2 = [...this.activityData];
		// 				_activityData2[this.index].guestsList = [...result];
		// 				this.$emit('update:activityData',_activityData2);				
		// 			}
					
		// 		}
		// 	}
		// },
        performersBind(v,index){
            this.index = index;
            // this.performerBindVisible = true;
            this.performer.value = this.activityData[this.index].performerList ? this.activityData[this.index].performerList : [] ;
            this.artistType = 1;
            const _data = {...v}
            if( _data.styles && _data.styles.length > 0 ){
                _data.styles = _data.styles.split(',');
            }
            if( _data.tags && _data.tags.length > 0 ){
                _data.tags = _data.tags.split(',');
            }
            this.currentArtist = _data;
            this.$refs.artistAdd.show(_data);
        },
		guestsBind(v,index){
			this.index = index;
			// this.performerBindVisible2 = true;
			this.guest.value = this.activityData[this.index].performerList2 ? this.activityData[this.index].performerList2 : [] ;
            this.artistType = 2;
            const _data = {...v}
            if( _data.styles && _data.styles.length > 0 ){
                _data.styles = _data.styles.split(',');
            }
            if( _data.tags && _data.tags.length > 0 ){
                _data.tags = _data.tags.split(',');
            }
            this.currentArtist = _data;
            this.$refs.artistAdd.show(_data);
		},
        updatePerformer(data){
            // const _activityData = [...this.activityData];
            // if( _activityData[this.index].artistList ){
            //     _activityData[this.index].artistList.push(data)
            // }else{
            //     _activityData[this.index].artistList = [data];
            // }
            const _activityData = [...this.activityData];
            if( this.artistType == 1 ){
                this.performer.value.push(data);
                _activityData[this.index].performerList = [...this.performer.value];
                //删除已绑定的艺人
                _activityData[this.index].customPerformer = _activityData[this.index].customPerformer.filter(item => item.name != this.currentArtist.name);
            }
            if( this.artistType == 2 ){
                this.guest.value.push(data);
                _activityData[this.index].performerList2 = [...this.guest.value];
                //删除已绑定的嘉宾
                _activityData[this.index].customGuest = _activityData[this.index].customGuest.filter(item => item.name != this.currentArtist.name);
            }
            this.$emit('update:activityData', _activityData);
            // this.$emit('update:activityData',_activityData);
        },
        // addPerformer(){
        //     this.$refs.artistAdd.show();
        // },
        // performerSubmit(){
        //     this.$refs["performerForm"].validate((valid) => {
        //         if(valid){
        //             const _activityData = [...this.activityData];
        //             _activityData[this.index].performerList = [...this.performer.value];
        //             this.$emit('update:activityData',_activityData);

        //             // this.performerBindVisible = false;
        //         }
        //     })
        // },
		// guestSubmit(){
		// 	this.$refs["guestForm"].validate((valid) => {
		// 	    if(valid){
		// 	        const _activityData = [...this.activityData];
		// 	        _activityData[this.index].performerList2 = [...this.guest.value];
		// 	        this.$emit('update:activityData',_activityData);
		// 			console.log(_activityData)
		// 	        // this.performerBindVisible2 = false;
		// 	    }
		// 	})
		// }
    }
}
</script>

<style lang="scss" scoped>
.container{
    &>li{
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        .el-button{
            padding: 0;
        }
        >div:first-child{
            margin-right: 10px;
            width: 120px;
            min-width: 100px;
            text-align: right;
            color: $--color-info;
        }
        ::v-deep .el-image{
            width: 200px;
            height: 200px;
        }
        &:nth-last-child(1){
            margin: 0;
        }
        span{
            // display: inline-block;
        }
        .flex-right{
            flex: 1;
            .el-tag{
                cursor: pointer;
            }
        }
    }
    .del-activity{
        width: 100%;
        text-align: left;
        // padding-left: 100px;
    }
}
</style>